import React from 'react';

import css from './Styles.module.scss';

const StickyBanner: React.FC<React.PropsWithChildren> = ({ children }) =>
{
  return (
    <div className={css.stickyBanner}>
        {children}
    </div>
  );
};

export default StickyBanner;